import { site } from '@/mocks/site';

export default function MethodSection() {
  return (
    <section id="method" className="relative overflow-hidden bg-primary-950 py-16 md:py-20">
      <div className="absolute -left-24 top-10 h-64 w-64 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-accent-500/15 blur-3xl" />

      <div className="relative mx-auto w-full px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 font-label text-xs tracking-wide text-background-100">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            前因后果深度拆解
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-background-50 md:text-4xl">
            我们怎么把一件事拆开讲
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-100/80 md:text-base">
            不靠猜测下结论，先确认时间顺序，再讨论因果。三条原则贯穿每一篇时间线，也决定了哪些内容会出现在页面上。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {site.principles.map((item, index) => (
            <div
              key={item.title}
              className="relative flex flex-col rounded-lg border border-background-50/15 bg-background-50/5 p-6 backdrop-blur"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-3xl font-bold text-background-50/25">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-100/80">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 rounded-lg border border-background-50/15 bg-background-50/5 p-6 backdrop-blur sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-node-tree text-lg" />
            </span>
            <p className="text-sm text-background-100/85">
              每篇拆解都标注了节点更新时间，事件还在发展就会持续追加。
            </p>
          </div>
          <a
            href="#hot"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 font-label text-sm text-foreground-950 transition-colors hover:bg-background-200"
          >
            回到今日热瓜
            <i className="ri-arrow-up-line" />
          </a>
        </div>
      </div>
    </section>
  );
}